/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sortDown': {
    width: 25,
    height: 24,
    viewBox: '0 0 25 24',
    data: '<path pid="0" d="M3.5 18h6v-2h-6v2zm0-12v2h18V6h-18zm0 7h12v-2h-12v2z" _fill="#0078D2"/>'
  }
})
